import * as React from 'react';
import { mergeClasses } from '../constants';

type Props = {
  className?: string;
  title: React.ReactNode;
  rightHalf?: React.ReactNode;
};

export default class ViewHeader extends React.Component<Props> {
  render() {
    const { className, title, rightHalf, ...rest } = this.props;
    return (
      <div className={mergeClasses(['d-flex', className])} {...rest}>
        <div className="flex-grow">
          <h1 className="mb-prs">{title}</h1>
        </div>
        {rightHalf && <div>{rightHalf}</div>}
      </div>
    );
  }
}
